import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const AbvLbeItemList = ({ lbeId }) => {

  const augRowsReq = useCallback((rowsReq) => {
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('lbeId', lbeId));
  }, [lbeId]);

  return (
    <EntityList entity="LBE_ITEM" augRowsReq={augRowsReq} />
  );
}